import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { v4 } from 'uuid';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  required: PropTypes.bool,
  counts: PropTypes.string,
  className: PropTypes.string
};
var defaultProps = {
  type: 'radio',
  onChange: function onChange() {}
};

function RadioButton(props) {
  var name = props.name;
      props.required;
      var id = props.id,
      counts = props.counts,
      className = props.className,
      disabled = props.disabled,
      label = props.label;
      props.checked;
      var onClick = props.onClick,
      onChange = props.onChange,
      value = props.value;
  var checkId = id || v4();
  var classes = classNames(className, 'prism-radio ', disabled && 'prism-radio--disabled');
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("label", {
    onChange: onChange,
    className: " align-items-center d-flex"
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: checkId,
    name: name || 'radio' // required={required || null}
    ,
    type: "radio",
    onClick: onClick,
    value: value
  }, props)), /*#__PURE__*/React.createElement("label", {
    htmlFor: checkId,
    className: " itemCol"
  }, label), counts && /*#__PURE__*/React.createElement("div", {
    className: "d-flex ml-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "prism-radio__counts"
  }, counts))));
}

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;

export default RadioButton;
//# sourceMappingURL=index.esm.js.map
